import React, { useContext, useEffect, useState } from 'react';
import AuthMaunfacturerSubHeader from 'src/components/manufacturer/authManufacturerSubHeader';
import useFetch from 'src/hooks/useFetch';
import { APIEndpoints } from 'src/types/apiTypes';
import { LocalCoverageResponseType } from './types';
import { downloadPdfFile } from 'src/helpers/downloadFile';
import { DownloadReportsResponseTypeApi } from 'src/components/manufacturer/statsReports/types';
import FooterText from "../../components/footerText";
import { AuthContext } from 'src/context/authContext';
import ContactAndSafetyInfo from 'src/components/contactAndSafetyInfo';
import { TextAlignProps } from 'src/components/contactAndSafetyInfo/types';
import {
  initializeSession,
  endSession,
  trackEvent,
  registerEventApi
} from "src/helpers/sessionTracker";

const CoverageLookup: React.FC = () => {
  const [zipCode, setZipCode] = useState<string>('');
  const [enabled, setEnabled] = useState<boolean>(false)
  const [enabledbutton, setEnabledButton] = useState<boolean>(false)

  const { isUserAuthorized, userData } = useContext(AuthContext);




  const { data: eventResponse, mutate: sendEvent } = useFetch(APIEndpoints.EVENT_ANALYTICS);

  useEffect(() => {
    if (eventResponse) {
      console.log("Event analytics sent:", eventResponse);
    }
  }, [eventResponse]);

  useEffect(() => {
    registerEventApi(sendEvent);
    initializeSession(userData || null);

    return () => {
      endSession();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  const { data: getLocalCoverage, mutate: localCoverageMutate } =
    useFetch<LocalCoverageResponseType>(APIEndpoints.LOCAL_COVERAGE);

  useEffect(() => {
    if (getLocalCoverage && getLocalCoverage.data && getLocalCoverage.data.formularies.length > 0) {
      setEnabled(true)
      setEnabledButton(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLocalCoverage]);

  const onSubmitData = (event: React.FormEvent) => {
    event.preventDefault();
    const searchValue = (document.getElementById('searchstr') as HTMLInputElement).value.trim();
    if (searchValue) {
      trackEvent("find", searchValue);
      setZipCode(searchValue);
      localCoverageMutate({}, {}, { searchstr: searchValue });
    } else {
      alert('Please enter a valid ZIP code.');
    }
  };

  const onclearData = () => {
    setEnabledButton(false);
    (document.getElementById('searchstr') as HTMLInputElement).value = '';
    setZipCode('');
    localCoverageMutate({}, {}, { searchstr: 0 });
  };




  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.DOWNLOAD_LOCAL_REQUEST_FORM);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      setEnabled(true)
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadPdfFile(response, `${report_name}.pdf`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = () => {
    trackEvent("download", zipCode);
    let params = {
      type: 'formulary',
      ref_type: 'RefFormulary',
      ref_id: zipCode,
    };

    if (downloadReportsData || downloadReportsError) clearRequestFileData();
    setEnabled(false);
    downloadRequestForm({}, {}, params);
  };




  return (
      <div className="local-coverage overflow-auto d-flex flex-column flex-fill">
          <div className={`flex-fill ${isUserAuthorized ? 'container-fluid' : 'container'}`}>
              <h2 className="fw-normal pt-3">ZILRETTA Local Coverage</h2>
              {isUserAuthorized ? <Description/> : <DescriptionNotAuthorized/>}
              <form onSubmit={onSubmitData}>
                  <input type="hidden" name="utf8" value="✓"/>
                  <div className="row mb-2 g-2">
                      <div className="col-12 col-md-9 col-lg-10">
                          <input type="text" name="searchstr" id="searchstr" className="form-control"
                                 placeholder="Search by five digit zipcode..."
                          />
                      </div>
                      <div className="col-12 col-md-3 col-lg-2">
                          <div className="row g-2">
                              <div className="col-6 col-md-6">
                                  <button type="button" className="btn btn-outline-secondary w-100"
                                          onClick={() => {
                                              onclearData() // Clear input field
                                          }}>Clear
                                  </button>
                              </div>
                              <div className="col-6 col-md-6">
                                  <button type="submit" className="btn btn-primary w-100">
                                      Search
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
              </form>
              <h4 className="heading bg-black text-white fw-medium">ZILRETTA<sup>®</sup> Coverage at
                  &nbsp;{(zipCode.length===0) ? '[Please enter search criteria above]' : (zipCode.toString())}
              </h4>
              <div className="table-responsive table-responsive-sm table-responsive-md table-responsive-lg" style={{border:'2px solid #697684'}}>
                  <table className="table table-striped m-0">
                      <thead>
                      <tr className="fs-5">
                          <th style={{width: '25%'}}></th>
                          <th className="text-white bg-gray">Channel</th>
                          <th className="text-white bg-gray">Medical Coverage</th>
                          <th className="text-white bg-gray">Pharmacy Coverage</th>
                      </tr>
                      <tr className="fs-5">
                          <th className="text-white bg-zilretta">Medicare Part B:</th>
                          <th className="fw-normal text-white bg-zilretta">Medicare</th>
                          <th className="fw-normal text-white bg-zilretta">Covered Without Restrictions</th>
                          <th className="fw-normal text-white bg-zilretta">See Medical Coverage</th>
                      </tr>
                      </thead>
                      <tbody>
                      {getLocalCoverage && getLocalCoverage.data && getLocalCoverage.data.formularies && getLocalCoverage.data.formularies.length > 0 ?
                          getLocalCoverage.data.formularies.map(kase => (
                              <tr>
                                  <td>{kase.payer_name}</td>
                                  <td>{kase.channel}</td>
                                  <td>{kase.medical_coverage}</td>
                                  <td>{kase.pharmacy_coverage}</td>
                              </tr>
                          )) : null
                      }
                      </tbody>
                  </table>
              </div>
              <h6 className="fw-bold m-0 p-2 text-center text-white bg-gray" style={{lineHeight:'normal'}}>
                  QUESTIONS? CONTACT YOUR FIELD REIMBURSEMENT MANAGER:&nbsp;
                  {getLocalCoverage &&  getLocalCoverage.data && getLocalCoverage.data.name +" "+ getLocalCoverage.data.email}
              </h6>

              <SafetyInfo/>
              {enabledbutton && <div className="text-end p-3">
                  <button className="btn btn-primary" onClick={() => downloadReport()} disabled={!enabled}>
                      Download
                  </button>
              </div>}
          </div>
          <FooterText footerType="black"/>
      </div>
  );
};

const SafetyInfo: React.FC = () => (
    <div className="bg-mist px-3 py-2">
        <p className="fw-bold m-0 pb-2">
            Please see Important Safety Information and full Prescribing Information available at{' '}
            <a
                href="https://www.zilrettapro.com/safety-data/"
                style={{color: "#0cb5b3"}}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("link", "https://www.zilrettapro.com/safety-data/")}
            >
                www.zilrettapro.com/safety-data/
            </a>
            .
        </p>
        <p className="m-0">
        <span style={{color: '#435364'}}>
          The information provided represents no statement, promise, or guarantee by Pacira BioSciences, Inc., concerning
          levels of reimbursement, payment, or charge.
          <br/>
          Please follow your standard procedure for conducting a benefit investigation for ZILRETTA.
          <br/>
          Consult your payer organization with regard to local or actual coverage,
          reimbursement policies, and determination processes. Information is subject to change without notice. Nothing
          herein may be construed as an endorsement, approval, recommendation, representation, or warranty of any kind
          by any plan or insurer referenced herein. This communication is solely the responsibility of Pacira
          BioSciences, Inc.
        </span>
        </p>
    </div>
);
const Description: React.FC = () => (
    <p>
      Search for formulary coverage Zip code below. Remember to submit a new request to conduct a full benefits
      investigation to determine patient-specific coverage details. Payers listed by the number of covered lives.
    </p>
);
const DescriptionNotAuthorized: React.FC = () => (
  <p>
    Search for formulary coverage Zip code below.
        Remember to
         <a href="/users/sign_in"> sign in </a> or
        <a href="/enrollments/new"> enroll </a> and conduct a full benefits
        investigation to determine patient-specific coverage details.
      Payers listed by the number of covered lives.
  </p>
);


export default CoverageLookup;
